import { IUpdateEntregaObraUseCase } from "../../../presentation/useCases/update/update_entrega_obra_use_case";
import { EntregaObraModel } from "../../models/entrega_obra_model";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateEntregaObraUseCase
 */

export class UpdateEntregaObraUseCase implements IUpdateEntregaObraUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(form: EntregaObraModel): Promise<void> {
    await this.repository.updateEntregaObra(
      form.idEntregaObra,
      form.status,
      form.idCentroCusto,

    );
  }

}
